/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopicCreation
 */
export interface TopicCreation {
    /**
     * 
     * @type {string}
     * @memberof TopicCreation
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TopicCreation
     */
    partitions: number;
    /**
     * 
     * @type {number}
     * @memberof TopicCreation
     */
    replicationFactor: number;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TopicCreation
     */
    configs?: { [key: string]: string | undefined; };
}

export function TopicCreationFromJSON(json: any): TopicCreation {
    return TopicCreationFromJSONTyped(json, false);
}

export function TopicCreationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopicCreation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'partitions': json['partitions'],
        'replicationFactor': json['replicationFactor'],
        'configs': !exists(json, 'configs') ? undefined : json['configs'],
    };
}

export function TopicCreationToJSON(value?: TopicCreation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'partitions': value.partitions,
        'replicationFactor': value.replicationFactor,
        'configs': value.configs,
    };
}

